module.exports = __webpack_public_path__ + "img/logo.62cb43ee.png";